import {
    createChannel,
    deleteChannel,
    getPostacellChannelSenders,
    getPostacellChannelCredit,
    getTeamGramPipelines,
    listChannels,
    updateChannel,
} from "../../api/channel";
import { PERMISSION_TYPES } from "../../language/permissionTypes";
import { sendSocketMessage } from "../../utils/socketStream";

const channel = {
    namespaced: true,
    state: {
        channels: [],
    },
    getters: {
        whatsappBusinessChannelExists: (state) => {
            return !!state.channels.find((x) => ["whatsapp-business-api", "whatsapp-business-api-supsis"].includes(x.type) && x.enabled);
        },
        anyWhatsappChannelExists: (state) => {
            return !!state.channels.find((x) => x.type.startsWith("whatsapp") && x.enabled);
        },

        getVisibleWhatsappChannels: (state, getters, rootState, rootGetters) => {
            const checkPermission = rootGetters["auth/checkPermission"];
            const filteredChannels = state.channels.filter((x) => {
                return ["whatsapp-qr", "whatsapp-v2", "whatsapp-business-api", "whatsapp-business-api-supsis", "whatsapp-unipile"].includes(x.type);
            });
            return filteredChannels.filter((x) => {
                const user = rootState.auth.user;
                const adminUser = rootState.auth.adminUser;
                const isRoot = user?.role?.isRoot || false;
                if (adminUser || isRoot) return true;
                const userId = user?._id;
                const userDepartments = user?.subjects || [];
                const visibilityUsers = x.visibility.users || [];
                const visibilityOwners = x.visibility.owners || [];
                const visibilityDepartments = x.visibility.departments || [];
                const departmentMatch =
                    userDepartments.some((department) => visibilityDepartments.includes(department)) ||
                    (userDepartments.length === 0 && !!visibilityDepartments.length);
                const userMatch = visibilityUsers.includes(userId);
                const isPublic = visibilityUsers.length === 0 && visibilityDepartments.length === 0;
                const isOwnerOfChannel = visibilityOwners.includes(userId);

                return (
                    isPublic ||
                    userMatch ||
                    departmentMatch ||
                    isOwnerOfChannel
                ); 
            });
        },
        getVisibleInstagramChannels: (state, getters, rootState, rootGetters) => {
            const checkPermission = rootGetters["auth/checkPermission"];
            const filteredChannels = state.channels.filter((x) => {
                return ["instagram", "instagram-v2"].includes(x.type);
            });
            return filteredChannels.filter((x) => {
                const user = rootState.auth.user;
                const adminUser = rootState.auth.adminUser;
                const isRoot = user?.role?.isRoot || false;
                if (adminUser || isRoot) return true;
                const userId = user?._id;
                const userDepartments = user?.subjects || [];
                const visibilityUsers = x.visibility.users || [];
                const visibilityDepartments = x.visibility.departments || [];
                const visibilityOwners = x.visibility.owners || [];
                const departmentMatch =
                    userDepartments.some((department) => visibilityDepartments.includes(department)) ||
                    (userDepartments.length === 0 && !!visibilityDepartments.length);
                const userMatch = visibilityUsers.includes(userId);
                const isPublic = visibilityUsers.length === 0 && visibilityDepartments.length === 0;
                const isOwnerOfChannel = visibilityOwners.includes(userId);
                console.log(`getVisibleInstagramChannels ${x.name}`, {
                    isPublic,
                    userMatch,
                    departmentMatch,
                    isOwnerOfChannel,
                    checkPermission: checkPermission(PERMISSION_TYPES["integrations.instagram.view"].tr.name),
                });
                return (
                    isPublic ||
                    userMatch ||
                    departmentMatch ||
                    isOwnerOfChannel ||
                    checkPermission(PERMISSION_TYPES["integrations.instagram.view"].tr.name) 
                );
            });
        },
        getVisibleMessengerChannels: (state, getters, rootState, rootGetters) => {
            const checkPermission = rootGetters["auth/checkPermission"];
            const filteredChannels = state.channels.filter((x) => {
                return ["messenger"].includes(x.type);
            });
            return filteredChannels.filter((x) => {
                const user = rootState.auth.user;
                const adminUser = rootState.auth.adminUser;
                const isRoot = user?.role?.isRoot || false;
                if (adminUser || isRoot) return true;
                const userId = user?._id;
                const userDepartments = user?.subjects || [];
                const visibilityUsers = x.visibility.users || [];
                const visibilityOwners = x.visibility.owners || [];
                const visibilityDepartments = x.visibility.departments || [];
                const departmentMatch =
                    userDepartments.some((department) => visibilityDepartments.includes(department)) ||
                    (userDepartments.length === 0 && !!visibilityDepartments.length);
                const userMatch = visibilityUsers.includes(userId);
                const isPublic = visibilityUsers.length === 0 && visibilityDepartments.length === 0;
                const isOwnerOfChannel = visibilityOwners.includes(userId);
                return (
                    isPublic ||
                    userMatch ||
                    departmentMatch ||
                    isOwnerOfChannel
                );
            });
        },
        getVisibleV1Channels: (state, getters) => {
            return []; // v1 kanalı kapatıldığı için burqdan da kaldırdım
            return getters.getVisibleWhatsappChannels.filter((x) => x.type === "whatsapp-qr");
        },
        getVisibleV2Channels: (state, getters) => {
            return getters.getVisibleWhatsappChannels.filter((x) => x.type === "whatsapp-v2");
        },
        getVisibleV3Channels: (state, getters) => {
            return getters.getVisibleWhatsappChannels.filter((x) => x.type === "whatsapp-unipile");
        },
        getVisibleBusinessChannels: (state, getters) => {
            return getters.getVisibleWhatsappChannels.filter((x) => ["whatsapp-business-api", "whatsapp-business-api-supsis"].includes(x.type));
        },
        isChannelVisibleForMe: (state, getters, rootState, rootGetters) => (channel) => {
            const user = rootState.auth.user;
            const adminUser = rootState.auth.adminUser;
            const isRoot = user?.role?.isRoot || false;
            if (adminUser || isRoot) return true;
            const userId = user?._id;
            const userDepartments = user?.subjects || [];
            const visibilityUsers = channel?.visibility?.users || [];
            const visibilityDepartments = channel?.visibility?.departments || [];
            const visibilityOwners = channel?.visibility?.owners || [];
            const departmentMatch =
                userDepartments.some((department) => visibilityDepartments.includes(department)) ||
                (userDepartments.length === 0 && !!visibilityDepartments.length);
            const userMatch = visibilityUsers.includes(userId);
            const isPublic = visibilityUsers.length === 0 && visibilityDepartments.length === 0;
            const checkPermission = rootGetters["auth/checkPermission"];
            const isOwnerOfChannel = visibilityOwners.includes(userId);
            return (
                isPublic ||
                userMatch ||
                departmentMatch ||
                isOwnerOfChannel
            );
        },
        isChannelVisibleForUser: (state, getters, rootState, rootGetters) => (channel, user) => {
            const adminUser = rootState.auth.adminUser;
            const isRoot = user?.role?.isRoot || false;
            if (adminUser || isRoot) return true;
            const userId = user?._id;
            const userDepartments = user?.subjects || [];
            const visibilityUsers = channel?.visibility?.users || [];
            const visibilityOwners = channel?.visibility?.owners || [];
            const visibilityDepartments = channel?.visibility?.departments || [];
            const departmentMatch = userDepartments.some((department) => visibilityDepartments.includes(department));
            const userMatch = visibilityUsers.includes(userId);
            const isPublic = visibilityUsers.length === 0 && visibilityDepartments.length === 0;
            const isOwnerOfChannel = visibilityOwners.includes(userId);
            const checkPermission = rootGetters["auth/checkPermission"];
            return (
                isPublic ||
                userMatch ||
                departmentMatch ||
                isOwnerOfChannel
            );
        },
    },
    mutations: {
        ADD_CHANNEL: (state, channel) => {
            state.channels = [...state.channels, channel];
        },
        SET_CHANNELS: (state, channels) => {
            state.channels = channels;
        },
        UPDATE_CHANNEL: (state, payload) => {
            state.channels = state.channels.map((p) => {
                if (p._id === payload._id) p = payload;
                return p;
            });
        },
        DELETE_CHANNEL: (state, channelId) => {
            state.channels = state.channels.filter((p) => p._id !== channelId);
        },
    },
    actions: {
        //list or resync channels
        listChannels({ commit }) {
            return listChannels()
                .then((response) => {
                    commit("SET_CHANNELS", response.data);
                    return response.data;
                })
                .catch((error) => {
                    console.log("listChannels error...", error);
                });
        },
        getChannel({ state }, id) {
            return state.channels.find((p) => p._id === id);
        },
        createChannel({ commit }, payload) {
            return createChannel(
                payload.type,
                payload.name,
                payload.payload,
                payload.visibility,
                payload.forward,
                payload.commentForward,
                payload.owner
            ).then((response) => {
                commit("ADD_CHANNEL", response.data);
                return response.data;
            });
        },
        updateChannel({ commit, rootState }, payload) {
            console.log("updateChannel", payload);
            return updateChannel(
                payload._id,
                payload.name,
                payload.enabled,
                payload.payload,
                payload.visibility,
                payload.forward,
                payload.commentForward,
                payload.zohoForward,
                payload.autoAssignDisabled,
                payload.capi,
                payload.accountNotifications
            ).then((response) => {
                const isSuccess = response.data;
                if (isSuccess) {
                    commit("UPDATE_CHANNEL", payload);

                    sendSocketMessage("user channel-sync", {
                        siteId: rootState.site?.site?._id,
                        channelId: payload._id,
                    });
                }
                return isSuccess;
            });
        },
        deleteChannel({ commit }, channelId) {
            return deleteChannel(channelId).then((response) => {
                const isSuccess = response.data;
                if (isSuccess) {
                    commit("DELETE_CHANNEL", channelId);
                }
                return isSuccess;
            });
        },
        getTeamGramPipelines({ commit }, channelId) {
            return getTeamGramPipelines(channelId).then((response) => {
                return response.data;
            });
        },

        getPostacellChannelCredit({}, channelId) {
            return getPostacellChannelCredit(channelId);
        },

        getPostacellChannelSenders({}, channelId) {
            return getPostacellChannelSenders(channelId);
        },
    },
};

export default channel;
